<template>
  <div style="width: 100%; height: 100%">
    <div class="header" :style="{background: web_top_bc}">
      <div class="logo">
        <img style="width: auto; height: 37%; max-height: 50px; margin-top: 5px" :style="{ height: web_logo_height + 'px'}" :src="web_logo" alt="" />
        <h3>{{web_title}}</h3>
      </div>

      <div style="margin-left: auto;">
        <Header></Header>
      </div>
    </div>

    <el-main class="Main_main_padding">
      <router-view></router-view>
    </el-main>
  </div>
</template>

<script>
import Header from './Header.vue'
export default {
    components: { Header },
    data() {
        return {
        activeIndex2: "/home",
        input3: "",
        header: "",
        exit: true,
        show_nav: true,
        statuss: 0,
        nickName: "",
        genre: ''
        };
    },
    methods: {
        handleSelect(key, keyPath) {
        console.log(key, keyPath);
        // this.$router.push(key)
        },
        goaokai() {},
        gowd() {
        this.$router.push({
            path: "/MultiPanel",
        });
        },
        scrollToTop() {
        let top = document.documentElement.scrollTop || document.body.scrollTop;
        // 实现滚动效果
        const timeTop = setInterval(() => {
            document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
            if (top <= 0) {
            clearInterval(timeTop);
            }
        }, 20);
        },
    },
    computed: {
        web_title () {
            if (this.$store.state.user_title && this.$store.state.user_title.length > 0) return this.$store.state.user_title
            else return this.$store.state.web_title
        },
        web_logo () {
            if (this.$store.state.user_logo && this.$store.state.user_logo.length > 0) return this.$store.state.user_logo
            else return this.$store.state.web_logo
        },
        web_logo_height () {
            if (this.$store.state.user_logo_height && this.$store.state.user_logo_height.length > 0) return this.$store.state.user_logo_height
            else return this.$store.state.web_logo_height
        },
        web_top_bc () {
            if (this.$store.state.user_top_bc && this.$store.state.user_top_bc.length > 0) return this.$store.state.user_top_bc
            else return this.$store.state.web_top_bc
        }
    },
    mounted() {
        console.log(this.$route.path)

        this.statuss = sessionStorage.getItem("status")
        this.nickName = sessionStorage.getItem("nickname")
        this.genre = sessionStorage.getItem("genre");

        if (this.nickName) {
            this.exit = false;
        }
    },
};
</script>

<style lang="less" scoped>

ul {
  list-style: none;
}
.header {
  display: flex;
  background: #303135;
  align-items: center;
  box-shadow: 0 1px 6px 0 rgb(0 0 0 / 10%);
}
.logo {
  margin-left: 2%;
  display: flex;
  justify-content: start;
  align-items: center;
}
.logo h3 {
  display: inline-block;
  font-size: 22px;
  margin: 17px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #fff;
}

.content ul {
  display: flex;
  justify-content: space-around;
  width: 60%;
  margin: 20px auto;
}

.main_bottom {
  width: 960px;
  margin: auto;
  padding: 45px 0 27px 0;

  .main_bottom_1 {
    .main_bottom_1_el-col {
      h3 {
        font-size: 15px;
        font-weight: 700;
        padding-bottom: 7px;
      }

      ul li {
        font-size: 15px;
        color: RGB(180, 180, 180);
        line-height: 25px;
      }
    }
  }

  .main_bottom_2 {
    text-align: center;

    img {
      width: 160px;
      height: 157px;
    }

    p {
      text-align: center;
      font-size: 15px;
      padding-top: 10px;
    }
  }

  p {
    padding-top: 40px;
    text-align: center;
  }
}

.Main_main_padding {
  padding: 0;
  width: 100%;
  height: 90%;
  overflow: visible !important;

  .Main_main_padding_nav {
    ul {
      position: fixed;
      bottom: 200px;
      right: 0;

      li {
        padding: 15px 10px 0;
        text-align: center;
        border-bottom: 1px dashed #afafaf;
        background-color: #e8e8e8;
        transition: 0.5s;
        position: relative;
        span {
          display: block;
          width: 25px;
          height: 25px;
          margin: 0 auto 5px;
          background: url(../../static/img/icon_APP_nor@2x.png) no-repeat center
            center;
        }
        img {
          display: block;
          width: 100px;
          height: 100px;
          position: absolute;
          right: -300px;
          bottom: -15px;
          transition: 1s;
        }
        div {
          width: 200px;
          height: 100px;
          position: absolute;
          right: -300px;
          bottom: -50px;
          transition: 1s;
          color: #fbb600;
        }
      }

      li:hover {
        color: #fff;
        background-color: #fbb600;
        span {
          background: url(../../static/img/icon_APP_Sel@2x.png) no-repeat center
            center;
        }
        img {
          right: 82px;
        }
        div {
          right: 82px;
        }
      }

      li:first-of-type {
        border-top-left-radius: 25%;
      }
      li:nth-of-type(2) {
        span {
          background: url(../../static/img/icon_feedback_nor@2x.png) no-repeat
            center center;
        }
      }

      li:nth-of-type(2):hover {
        span {
          background: url(../../static/img/icon_feedback_Sel@2x.png) no-repeat
            center center;
        }
      }

      li:nth-of-type(3) {
        span {
          background: url(../../static/img/icon_top_nor@2x.png) no-repeat center
            center;
        }
      }

      li:nth-of-type(3):hover {
        span {
          background: url(../../static/img/icon_top_Sel@2x.png) no-repeat center
            center;
        }
      }
      li:last-of-type {
        border-bottom-left-radius: 25%;
        border: 0;
        padding-bottom: 2px;
      }
    }
  }
}

.main_div {
  height: 62px;
}

.main_div .main_button {
  float: right !important;
  margin-left: 15px;
  margin-top: 15px;
  cursor: pointer;
  border-radius: 50%;
  border: 1px solid #ccc;
}

.main_buttontou {
  float: right !important;
  margin-left: 5px;
  margin-top: 26px;
  cursor: pointer;
}

.main_buttonicon {
  float: right !important;
  margin-left: 15px;
  margin-top: 22px;
  font-size: 22px;
  cursor: pointer;
}

.main_div .main_button span {
  font-size: 12px;
}
.main_ul {
  text-align: center;
  margin-top: 8px;

  li {
    float: left;
    width: 70px;
    height: 55px;
    line-height: 55px;
    margin-right: 27px;
    font-size: 17px;
    transition: 0.1s;
  }

  li:hover {
    border-bottom: 5px solid #fbb600;
  }

  li:last-child {
    margin-right: 0;
  }

  .sel {
    border-bottom: 5px solid #fbb600;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main.vue